<template>
    <div>
        <div class="row head">
            <div class="col col-100">Email wijzigen</div>
        </div>

        <div class="row row-single setting">
            <div  v-if="$root.app.platform == 'android'" class="col col-100" v-bind:class="{ 'validation-error': $v.data.email.$error }">
                <span class="row__title">Nieuw E-mail</span><br/>
                <input v-model="data.email" type="text" @input="$v.data.email.$touch()"/>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50" v-bind:class="{ 'validation-error': $v.data.email.$error }">
                <span class="row__title">Nieuw E-mail</span>
                
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50">
                <input v-model="data.email" type="text" @input="$v.data.email.$touch()"/>
            </div>
        </div>

        <div class="row spacer">&nbsp;</div>

        <div class="row">
            <div class="col col-100">
                <button class="button dub-button dub-button-space" @click="editEmail">Gegevens opslaan</button>
            </div>
        </div>

    </div>
</template>

<script>
import { required, minLength, maxLength, email } from 'vuelidate/lib/validators'

export default {
    name: 'PasswordEdit',
    data() {
        return {
            data: [],
        }
    },

    validations: {
         data:{
            email: {
                required,
                minLength: minLength(4),
                email
            }
        },
    },

    methods:{
        editEmail() {

            if(this.$v.$invalid) {
                this.$root.ui.showDialog(
                    'Fout',
                    'Het ingevulde e-mail adres is niet correct<br/>',
                    true
                );
                return;
            }

            var _this = this;
            var root = this.$root;
            root.loading = true;
            root.app.state = 'save';



            this.$api.post('/account', this.data)
            .then(response => {

                root.loading = false;
                root.app.state = 'get';

                _this.$root.ui.showDialog(
                    'Voltooid',
                    'Email is gewijzigd.',
                    true
                );
                this.$router.go(-1); //Back to /app
            })
            .catch(e => {

                root.loading = false;
                root.app.state = 'get';

                _this.$root.ui.showDialog(
                    'Fout',
                    'De gegevens konden niet worden opgeslagen door een fout:<br/>'+e.response.data.message,
                    true
                );
            })
        }
    },

    mounted(){

        this.$api.get('/account')
        .then(response => {

            this.data = response.data;
        })
        .catch(e => {

        })
    },
}
</script>




// WEBPACK FOOTER //
// src/components/EmailEdit.vue